import toast from "react-hot-toast";

const AlertTost = (content, type) => {
  if (type === "success") {
    toast.success(content, {
      duration: 2000,
      position: "top-right",
      className: "",

      // Custom Icon
      style: {
        borderRadius: "10px",
        background: "#4caf50",
        color: "#fff",
      },

      // Change colors of success/error/loading icon
      iconTheme: {
        primary: "#000",
        secondary: "#fff",
      },

      // Aria
      ariaProps: {
        role: "status",
        "aria-live": "polite",
      },
    });
  } else if (type === "error") {
    toast.error(content, {
      duration: 2000,
      position: "top-right",
      className: "",

      // Custom Icon
      style: {
        borderRadius: "10px",

        // backgroundImage: "url('assets/images/background/imgErrorBg.png')",
        background: "#e74c3c",
        color: "#fff",
        backgroundSize: "cover",
        backgroundColor: "red !important",
      },

      // Change colors of success/error/loading icon
      iconTheme: {
        primary: "#000",
        secondary: "#fff",
      },

      // Aria
      ariaProps: {
        role: "status",
        "aria-live": "polite",
      },
    });
  }
};

export default AlertTost;
